import { useEffect, useState } from 'react';
import { Modal, Radio } from 'antd';
import type { RadioChangeEvent } from 'antd';

interface ViewSelectOption<T extends string> {
    label: string;
    value: T;
}

interface ViewSelectModalProps<T extends string> {
    open: boolean;
    title: string;
    label: string;
    options: ReadonlyArray<ViewSelectOption<T>>;
    initialValue: T;
    onCancel: () => void;
    onApply: (value: T) => void;
}

function ViewSelectModal<T extends string>({
    open,
    title,
    label,
    options,
    initialValue,
    onCancel,
    onApply,
}: ViewSelectModalProps<T>) {
    const [draft, setDraft] = useState<T>(initialValue);

    useEffect(() => {
        if (open) setDraft(initialValue);
    }, [open, initialValue]);

    const handleChange = (e: RadioChangeEvent) => setDraft(e.target.value as T);

    return (
        <Modal
            title={title}
            open={open}
            width={480}
            onCancel={onCancel}
            onOk={() => onApply(draft)}
            okText="Apply"
            cancelText="Cancel"
            destroyOnClose
        >
            <div className="flex flex-col gap-y-3">
                <p className="text-sm text-[#52525C]">{label}</p>
                <Radio.Group value={draft} onChange={handleChange}>
                    <div className="flex flex-col gap-y-3">
                        {options.map((opt) => (
                            <Radio key={opt.value} value={opt.value}>
                                {opt.label}
                            </Radio>
                        ))}
                    </div>
                </Radio.Group>
            </div>
        </Modal>
    );
}

ViewSelectModal.displayName = 'ViewSelectModal';
export default ViewSelectModal;
